import { render, staticRenderFns } from "./AwsService.vue?vue&type=template&id=46e80303&scoped=true&"
import script from "./AwsService.vue?vue&type=script&lang=js&"
export * from "./AwsService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e80303",
  null
  
)

export default component.exports